







import XInput from 'vux/src/components/x-input/index.vue'

export default {
name: "chatframe",
components: {
XInput,
},
props: {
values:String,
itemValue:String,










},
data() {
return {
value:this.values
}
},
mounted() {
this.$emit("onInput",this.value)
},
beforeDestroy() {

},
methods:{

onDelOneInput()
{

this.$emit("onDelOneInput",0)
},
},
watch:{
value(value)
{
this.$emit("onInput",value)
},
values(val)
{

console.log('%c⧭', 'color: #00736b', "val","======")


},
itemValue(val)
{
console.log('%c⧭', 'color: #cc7033', val,"---")
this.value = val;
this.$emit("onInput",val)
}
}
}



// WEBPACK FOOTER //
// ./src/myComponents/oneInput/oneInput.vue